import React, { useState, useRef, useEffect } from "react";
import wops from './assets/July/july.png';
import two from './assets/July/2.png';
import three from './assets/July/3.png';
import four from './assets/July/4.png';
import five from './assets/July/5.png';
import six from './assets/July/6.png';
import seven from './assets/July/7.png';
import eight from './assets/July/8.png';
import pet from './assets/pet.jpg';
import eml from './assets/eml.jpg';
import { Link } from 'react-router-dom';
import './case.css';
import emailjs from '@emailjs/browser';





const Sunscreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); //for scroll to the top always I mean whenever the page opens the page will be at the top

    const [notification, setNotification] = useState("");
    const [isOverlayVisible, setOverlayVisible] = useState(false);

    const toggleOverlay = () => {
        setOverlayVisible(!isOverlayVisible);
    };
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        // Get form data
        const formData = new FormData(form.current);
        const name = formData.get("user_name");
        const email = formData.get("user_email");
        const subject = formData.get("user_subject");
        const message = formData.get("message");

        // Check if any field is empty
        if (!name || !email || !subject || !message) {
            setNotification("All fields are required!");
            setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
            return;
        }

        emailjs
            .sendForm('service_mh1ddkn', 'template_2zi8jcs', form.current, 'dBrGazk0t-K47QR2W')
            .then(
                () => {
                    setNotification("Message sent successfully!");
                    form.current.reset(); // Reset form fields
                    setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
                },
                (error) => {
                    setNotification("Failed to send message. Try again!");
                    setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
                    console.log("FAILED...", error.text);
                }
            );
    };

    const [position, setPosition] = useState({ x: 0, y: 0 });
            const [hovered, setHovered] = useState(false);
        
            useEffect(() => {
                const handleMouseMove = (e) => {
                    setPosition({ x: e.clientX, y: e.clientY });
                };
        
                document.addEventListener("mousemove", handleMouseMove);
        
                return () => {
                    document.removeEventListener("mousemove", handleMouseMove);
                };
            }, []);
        
            useEffect(() => {
                const clickableElements = document.querySelectorAll("button, a, .logo, svg");
        
                clickableElements.forEach((element) => {
                    element.addEventListener("mouseenter", () => setHovered(true));
                    element.addEventListener("mouseleave", () => setHovered(false));
                });
        
                return () => {
                    clickableElements.forEach((element) => {
                        element.removeEventListener("mouseenter", () => setHovered(true));
                        element.removeEventListener("mouseleave", () => setHovered(false));
                    });
                };
            }, []);
    return (
        <div className="case-container">
            <div className={`cursor ${hovered ? "cursor-hover" : ""}`} style={{ left: `${position.x}px`, top: `${position.y}px` }} />
            <div className="navbar" >
                <p onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'pointer' }}>pranav.</p>
                <svg onClick={toggleOverlay} width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="5" rx="2.5" fill="#101010" />
                    <rect y="10" width="30" height="5" rx="2.5" fill="#101010" />
                    <rect y="20" width="30" height="5" rx="2.5" fill="#101010" /></svg>

                <ul className={`overlay ${isOverlayVisible ? "show" : ""}`}>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/">home.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/allprojects">project.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/about">about.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/contact">contact.</Link></li>
                    </div>
                    <div className="available">
                        <div className="dot-green"></div>available for freelance.
                    </div>
                </ul>
            </div>

            <div className="sliding-container">
                <div className="static">
                    <div className="contents">
                        <a href="/allprojects">go back.</a>
                        <h1>july.</h1>
                        <p>created the packaging design for GIF Chips, combining bold and vibrant visuals to reflect the brand's playful and energetic personality.  <br /> <br />The design features dynamic typography, striking colors, and appetizing imagery to capture attention and convey the product's delicious and fun nature, ensuring it stands out on store shelves.</p>
                        <div className="tags">
                            <p>package designing.</p>
                        </div>
                    </div>
                    <Link to="/allprojects"><button>all projects.</button></Link>
                </div>
                <div className="slider">

                    <div className="images">

                        <div className="image-container-hero">
                            <img src={wops} />
                        </div>
                        <div className="contents-mobile">
                            <a href="/allprojects">go back.</a>
                            <h1>july.</h1>
                            <p>created the packaging design for GIF Chips, combining bold and vibrant visuals to reflect the brand's playful and energetic personality.  <br /> <br />The design features dynamic typography, striking colors, and appetizing imagery to capture attention and convey the product's delicious and fun nature, ensuring it stands out on store shelves.</p>
                            <div className="tags">
                                <p>package designing.</p>
                            </div>
                        </div>

                        <div className="image-stack">
                            <div className="image1">
                                <img src={two} />
                            </div>
                            <div className="image1">
                                <img src={three} />
                            </div>
                        </div>

                        <div className="image-container">
                            <img src={four} />
                        </div>

                        <div className="image-stack">
                            <div className="image1">
                                <img src={five} />
                            </div>
                            <div className="image1">
                                <img src={six} />
                            </div>
                        </div>

                        <div className="image-container">
                            <img src={seven} />
                        </div>

                        <div className="image-container">
                            <img src={eight} />
                        </div>

                    </div>
                </div>
            </div>

            <div className="more">
                <h1>other projects.</h1>
                <div className="box-container">
                    <Link to="/eml" className="box">
                        <div className="image">
                            <img src={eml} />
                        </div>
                        <div className="context">
                            <h2>elizabeth milan london.</h2>
                            <div className="tags">
                                <p>ui redesign.</p>
                            </div>
                        </div>
                    </Link>

                    <Link to="/pet" className="box">
                        <div className="image">
                            <img src={pet} />
                        </div>
                        <div className="context">
                            <h2>petvouge.</h2>
                            <div className="tags">
                                <p>ui/ux design.</p>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <div className="missed-heading" id="contact">
                <h1>say hi.</h1>
                <div id="getintouch" className="sayhi">
                    <div className="contact-title">
                        <h1>let’s collaborate.</h1><br />
                        <p>have any idea in your mind?</p>
                        <p>fell free to reach out.</p>
                    </div>
                    <form className="contact" ref={form} onSubmit={sendEmail}>
                        <div className="textboxes">
                            <p>name.</p>
                            <input name="user_name" placeholder="John Doe" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>email.</p>
                            <input name="user_email" type="email" placeholder="example@gmail.com" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>subject.</p>
                            <input name="user_subject" placeholder="project abc" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>message.</p>
                            <input name="message" className="message" placeholder="I want your help in..." id=""></input>
                        </div>
                        <button type="submit" className="submit">submit.</button>
                    </form>
                </div>
            </div>

            {/* Popup Notification */}
            {notification && (
                <div className="popup">
                    <p>{notification}</p>
                </div>
            )}

            <footer>
                <p>designed and developed by</p>
                <ul>pranav pradeep.</ul>
            </footer>
        </div>
    );
};
export default Sunscreen;